import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface ResultsKeyType {
  plural: LocalesKey;
  pluralGenitiveLowerCase: LocalesKey;
  download: LocalesKey;
  filter: LocalesKey;
  see: LocalesKey;
  singular: LocalesKey;
  singularLowerCase: LocalesKey;
  hide: LocalesKey;
  cancel: LocalesKey;
  uploadToLibrary: LocalesKey;
  searchByImage: LocalesKey;
  searchResultsByImage: LocalesKey;
  similarTo: LocalesKey;
  clearImageSearch: LocalesKey;
  clickToReplaceTheImage: LocalesKey;
  uploadImageForSearch: LocalesKey;
}

export const resultsKeys = keyPathMirror<ResultsKeyType, string>(
  {
    plural: null,
    pluralGenitiveLowerCase: null,
    download: null,
    filter: null,
    see: null,
    singular: null,
    singularLowerCase: null,
    hide: null,
    cancel: null,
    uploadToLibrary: null,
    searchByImage: null,
    searchResultsByImage: null,
    similarTo: null,
    clearImageSearch: null,
    clickToReplaceTheImage: null,
    uploadImageForSearch: null
  },
  'models.results.'
);
